import { useCallback, useEffect } from "react"
import {
	BIChartData,
	BIChartLegendVisibility,
	BIFilters,
	BIFormData,
	BIIsLoadingChart,
	BIIsLoadingTable, BISelectedOfficeOptions,
	BISelectedOffice,
	BITableData,
	clearBISignals, BIIs3DTable, BIHeaders, BISubHeaders, BI3DTableData, BIGroupingHeader,
} from 'Pages/BusinessLogistics/BI/Page/@signals'
import { postSubmit } from "@ui-seeker/utils"
import { BACKEND_APIS } from "@constants"
import { useToast } from "@hooks"
import { isLoadingCommonFilters } from "@signals"
import { batch } from "@preact/signals-react"

export default function useSubmitBIFilters() {

	const { showToast } = useToast()

	useEffect(() => {
		if (isLoadingCommonFilters.value) onSubmit()
	}, [isLoadingCommonFilters.value])


	const onSubmit = useCallback(() => {
		clearBISignals()
		batch(() => {
			BIIsLoadingTable.value = true
			BIIsLoadingChart.value = true
		})
		postSubmit(`${BACKEND_APIS.DASHBOARD}/results`, BIFormData.value)
			.then(res => {
				BIIs3DTable.value = res.is3Dimesions
				BISelectedOfficeOptions.value = res?.officeSelector?.length ? res?.officeSelector : []
				BIFilters.value = res.filters
				if(!res.is3Dimesions) {
					BITableData.value = {
						trows: {
							avg: res.tableDataAvg,
							min: res.tableDataMin,
							max: res.tableDataMax,
						},
						columnValues: res.xlist,
						rowValues: res.rowValues,
						noResults: res.no_results
					}
					BIChartData.value = {
						chartData: {
							avg: res.chartDataAvg,
							min: res.chartDataMin,
							max: res.chartDataMax,
						},
						keySeries: res.keySeries,
						xlist: res.xlist
					}
					BIChartLegendVisibility.value = res.keySeries.map(({ dataKey }) => dataKey)
				} else {
					BIHeaders.value = res.headers
					BISubHeaders.value = res.subHeaders
					BI3DTableData.value = {
						avg: res.results.avg_price,
						min: res.results.min_price,
						max: res.results.max_price
					}
					BIGroupingHeader.value = res.columnName
				}

				showToast.success('Search finished')
				batch(() => {
					BIIsLoadingTable.value = false
					isLoadingCommonFilters.value = false
					BIIsLoadingChart.value = false
				})
			})
			.catch(() => {
				showToast.error('Something went wrong!')
				batch(() => {
					BIIsLoadingTable.value = false
					isLoadingCommonFilters.value = false
					BIIsLoadingChart.value = false
				})
			})
	}, [JSON.stringify(BIFormData.value), BISelectedOffice.value])

}